// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface FileTasksCheckIconSignature {
  Element: SVGSVGElement;
}

export const FileTasksCheckIcon: TOC<FileTasksCheckIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M19 5H17V3H15.858C15.411 1.281 13.858 0 12 0C10.142 0 8.589 1.281 8.142 3H7V5H5C3.897 5 3 5.898 3 7V21C3 22.103 3.897 23 5 23H19C20.103 23 21 22.103 21 21V7C21 5.898 20.103 5 19 5ZM11 15.586L8.707 13.293L7.293 14.707L11 18.415L16.707 12.707L15.293 11.293L11 15.586ZM13.731 3C13.385 2.402 12.739 2 12 2C11.261 2 10.615 2.402 10.268 3H13.731ZM15 5V7H9V5H15ZM5 21H19V7H17V9H7V7H5V21Z"/>
</svg>
</template>;